import "../css/TeeStyles.css";
import Logo from "../icons/assets/logo.png";
import facebook from "../icons/assets/facebook.png";
import instagram from "../icons/assets/instagram.png";
import x from "../icons/assets/x.png";
import splash from "../icons/assets/slash.png";
import { Link } from "react-router-dom";
import React from "react";

const SectionSix: React.FC = () => {
  return (
    <div
      className="section bgWhite position-relative px-0"
      style={{ zIndex: 1 }}
    >
      <img src={Logo} alt="" className="d-block mx-auto mt-5" />
      <div className="d-block mx-auto wid50 wid50Mobile px-2 px-md-0 mt-4">
        <div className="d-flex justify-content-between">
          <Link
            to={"/services"}
            //   style={{ color: buttonColor, border: `solid 2px ${buttonColor}` }}
            className="fontSize14px mcm-dark-color boldSeven text-center d-block pb-4"
          >
            SERVICES
          </Link>
          <Link
            to={"/about"}
            //   style={{ color: buttonColor, border: `solid 2px ${buttonColor}` }}
            className="fontSize14px mcm-dark-color boldSeven text-center d-block pb-4"
          >
            ABOUT US
          </Link>
          <Link
            to={"/"}
            //   style={{ color: buttonColor, border: `solid 2px ${buttonColor}` }}
            className="fontSize14px mcm-dark-color boldSeven text-center d-block pb-4"
          >
            CONTACT
          </Link>
          <Link
            to={"/"}
            //   style={{ color: buttonColor, border: `solid 2px ${buttonColor}` }}
            className="fontSize14px mcm-dark-color boldSeven text-center d-block pb-4"
          >
            MarkCalthersConsulting
          </Link>
        </div>
        <div className="d-block wid20Mobile my-2 wid50 mx-auto">
          <div className="d-flex justify-content-between flex-wrap wid100">
            <Link
              to="mailto:mcm@markcalthers.com"
              className="fontSize14px mcm-dark-color boldSeven text-center d-block pb-4"
            >
              mcm@markcalthers.com
            </Link>
            <Link
              to="tel:07010998326"
              className="fontSize14px mcm-dark-color boldSeven text-center d-block pb-4"
            >
              07010098326
            </Link>
          </div>
          <Link
            to="https://maps.app.goo.gl/QNV83ajSGdgmKkuXA"
            className="fontSize14px mcm-dark-color boldSeven text-center d-block pb-2"
          >
            Address: 14, Lanre Awolokun Str, Gbagada, Lagos
          </Link>
        </div>
        <img src={splash} alt="" className="d-block mx-auto mt-4" />
        <div className="d-flex justify-content-center mt-4">
          <Link
            to={"https://web.facebook.com/MarkCalthersMediaStudio"}
            //   style={{ color: buttonColor, border: `solid 2px ${buttonColor}` }}
            className="fontSize14px mcm-dark-color boldSeven text-center d-block m-2 pb-4"
          >
            <img src={facebook} alt="" />
          </Link>
          <Link
            to={
              "https://www.instagram.com/markcalthersmediastudioo/profilecard/?igsh=M2U3MTZtOTRzZmw3"
            }
            //   style={{ color: buttonColor, border: `solid 2px ${buttonColor}` }}
            className="fontSize14px mcm-dark-color boldSeven text-center  m-2 d-block pb-4"
          >
            <img src={instagram} alt="" />
          </Link>
          <Link
            to={"https://x.com/MCMStudioo?t=ktPibE3SA3b2ENSeNzroSA&s=09"}
            //   style={{ color: buttonColor, border: `solid 2px ${buttonColor}` }}
            className="fontSize14px mcm-dark-color boldSeven text-center  m-2 d-block pb-4"
          >
            <img src={x} alt="" />
          </Link>
        </div>
        <span className="d-block mt-3 mb-3 fontSize10px boldFour text-center mcm-dark-color-light">
          © Copyright 2024. All Rights Reserved
        </span>
      </div>
    </div>
  );
};

export default SectionSix;
